import type { ContentSnippetApiData } from '@packages/modules/src/PromotionBanner/types';
import { useRouter } from 'next/router';
import useSWR from 'swr';

export const useNlSheetTexts = (
  fallbackNlSheetTexts: ContentSnippetApiData | undefined = undefined,
) => {
  const { locale: language, defaultLocale: defaultLanguage } = useRouter();
  const finalLanguage = language || defaultLanguage || 'de';
  const nlSheetTextsCacheKey = `nlSheetData-${finalLanguage}`;
  const { data } = useSWR<ContentSnippetApiData>(nlSheetTextsCacheKey, {
    fallbackData: fallbackNlSheetTexts,
  });
  const nlTexts =
    data?.data?.[0] && data.data[0].type === 'content_snippet_bundled--nl_sheet' && data.data[0];
  return {
    nlTexts,
    endpoint: nlSheetTextsCacheKey,
  };
};
